document.addEventListener("turbolinks:load", function() {
	$(document).on("click","[data-standard-issue-photo]", function() {
		$("#tag_photo").prop('disabled', true);
    $("#tag_photo").val('');
	});
})
